export { default as TeamProfileSecondaryMenu } from './TeamProfileSecondaryMenu';
